import { render, staticRenderFns } from "./myinfo-address.vue?vue&type=template&id=66ab2d94&"
import script from "./myinfo-address.vue?vue&type=script&lang=js&"
export * from "./myinfo-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports